<template>
  <app-layout ref="lo" title="Dashboard">
    <template #header>
      <BreadCrumb :breadcrumb="$page.props.bc"/>
    </template>

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <section class="text-gray-600 body-font">
            <div class="container px-5 py-12 mx-auto">
              <!--                            buat dialog dengan input tanggal-->
              <div class="flex flex-wrap w-full mb-5 flex-col">
                <Toolbar>
                  <template #start>
                    <ButtonLink
                        url="penetapan/pegawai"
                        class="mr-1"
                        v-if="$page.props.session_role?.role?.name == 'adminkpbj'"
                    >Buat Penetapan User
                    </ButtonLink>
                  </template>
                  <template #end>
                  </template>
                </Toolbar>
              </div>
              <div class="w-full mb-20">
                <EzDataTable
                    ref="ezdt"
                    :config="ezdtConfig"
                    @getSelectedData="getSelected"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import {defineComponent} from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import ButtonAdd from "@/Components/ButtonAdd.vue";
import Dialog from 'primevue/dialog';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import {Pesan} from "@/constants";
import ButtonLink from "@/Components/ButtonLink.vue";

export default defineComponent({
  components: {
    ButtonLink,
    AppLayout,
    BreadCrumb,
    EzDataTable,
    Toolbar,
    Button,
    ButtonLinkAdd,
    ButtonLinkEdit,
    ButtonLinkShow,
    ButtonDelete,
    ButtonEdit,
    ButtonAdd,
    Dialog,
    JetLabel,
    Input,
  },
  data() {
    return {
      sk_drm: '',
      ezdtConfig: {
        dtHeader: "Daftar Penetapan User",
        globalFilter: ["file_sk"],
        sortBy: "created_at",
        defineCols: [
          {
            field: "is_aktif",
            header: "Status Aktif",
            style: "min-width: 5rem",
            // isFrozen: true,
            col_type: "boolean",
          },
          {
            field: "status",
            header: "Status Verifikasi",
            style: "min-width: 5rem",
            col_type: "boolean",
          },
          {
            field: "file_sk",
            header: "Surat Keputusan",
            style: "min-width: 10rem",
            // isFrozen: true,
            col_type: "text",
          },

          {
            field: "role.name",
            header: "Nama Role",
            style: "min-width: 5rem",
            col_type: "text",
          },


        ],
        dtSourceApiRoute: {
          list: "penetapan.dataPenetapan",
          show: "penetapan.show",
          // edit: "penyedia.edit",
          // destroy: "penyedia.destroy",
        },
      },
      selected: [],
      selected_id: 0,
      allow_to_proceed: true,
      displayBasic: false,
      tanggal: null,
      keterangan: null,
      lokasi: null,
    };
  },
  methods: {
    loadEzData: function () {
      // this.allow_to_proceed = false;
      this.$refs.ezdt.loadData();
    },
    getSelected: function (data) {
      this.selected = data;
      this.selected_id = 0;
      if (data.length == 1) {
        this.selected_id = data[0]["user_id"];
        console.log(this.selected_id);
      }
    },
    tambah: function (event) {
      //
    },
    edit: function (event) {
      //
    },



  },
});
</script>
